import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";

function SignupDropdown() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (url) => {
    handleClose();
    window.location.href = url; // Navigate to external site
  };

  return (
    <div>
      <Button
        id="signup-button"
        aria-controls={open ? "signup-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onMouseEnter={handleMouseEnter}
        sx={{
          textTransform: "capitalize",
          padding: "8px 16px",
        }}
        className="mx-3 signup"
      >
        Signup
      </Button>
      <Menu
        id="signup-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        MenuListProps={{
          "aria-labelledby": "signup-button",
          onMouseLeave: handleClose,
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            minWidth: "120px",
          },
        }}
      >
        <MenuItem
          onClick={() =>
            handleMenuItemClick(process.env.REACT_APP_SCHOOL_REGISTER)
          }
          className="hover:bg-gray-100"
        >
          School Signup
        </MenuItem>
        <MenuItem
          onClick={() =>
            handleMenuItemClick(process.env.REACT_APP_SCHOOL_REGISTER)
          }
          className="hover:bg-gray-100"
        >
          College Signup
        </MenuItem>
      </Menu>
    </div>
  );
}

export default SignupDropdown;
